export function notificationDestination(message, account) {
    const data = message?.data || message || {};
    const kind = message?.notifType || data.type || '';
    const permissions = account?.permissions || [];
    const allowed = tag => permissions.includes(tag) || account?.is_superuser === true;
    if (kind.startsWith('fine') || kind === 'deduction') {
        if (account?.role === 'workstation') return '/workstation/fines';
        return allowed('finance.fines.view') ? '/manager/fines' : '/my-fines';
    }
    if (kind.startsWith('reward') || kind === 'daily_reward') return allowed('finance.rewards.view') ? '/manager/rewards' : '/my-salary';
    let raw = message?.url || data.url || '/';
    if (typeof raw !== 'string') return '/';
    try {
        const target = new URL(raw, window.location.origin);
        if (target.origin !== window.location.origin) return '/';
        raw = target.pathname + target.search + target.hash;
    } catch { return '/'; }
    // These personal routes also accept manager/custom-role accounts.
    if (raw.startsWith('/manager') && account?.role !== 'manager' && !allowed('events.view') && !permissions.some(p => p.startsWith('schedule.') || p.startsWith('finance.'))) return '/';
    return raw;
}
